module.exports = __webpack_public_path__ + "img/logo-happy-kids.3d54f7b.svg";